/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/library_update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdLibraryUpdateTagsCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdLibraryUpdateTagsProps,
  EngagementAppGroupIdLibraryUpdateTagsResult,
} from "./types";

export const postEngagementAppGroupIdLibraryUpdateTags = reactQueryMutationAdapter(
  engagementAppGroupIdLibraryUpdateTagsCacheKeys,
  ({
    desired_state,
    undo_identifier,
    app_group_id,
  }: PostEngagementAppGroupIdLibraryUpdateTagsProps): Promise<EngagementAppGroupIdLibraryUpdateTagsResult> => {
    return fetch(`/engagement/${app_group_id}/library_update_tags`, "POST", { desired_state, undo_identifier });
  }
);
